import { AuthService } from '@abp/ng.core';
import {  Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';


@Injectable({
  providedIn: 'root',
})
export class AuthGuard {

  constructor(private authService: AuthService,) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated) {
      return true;

    } else {
      this.authService.navigateToLogin({ returnUrl: state.url });
      return false;
    }
  }


}
